<template>
  <div class="page6">
    <GraphValidateCode @graph="graphFun" ref="graphOneself"></GraphValidateCode> 
    <!-- 上 -->
    <img v-for="img in imageList1" v-lazy="img" width="100%" style="display: block;">
    <!-- 表单1 -->
    <div class="form_box">
        <div style="border:1px solid #d4d4d4">
          <!-- 孩子姓名 -->
          <van-cell-group>
            <van-field
              v-model="form.name"
              label="孩子姓名"
              placeholder="请输入孩子姓名"
            />
          </van-cell-group>
          <!-- 孩子年龄 -->
          <van-field
            readonly
            clickable
            label="孩子年龄"
            :value="age"
            placeholder="请选择孩子年龄"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <!-- 家长手机号 -->
          <van-cell-group>
            <van-field
              v-model="form.phone"
              type="number"
              label="家长手机号"
              placeholder="请输入家长手机号"
            />
          </van-cell-group>
          <!-- 验证码 -->
          <van-cell-group>
            <van-field
              v-model="form.code"
              type="number"
              center
              clearable
              label="短信验证码"
              placeholder="请输入短信验证码"
            >
              <van-button slot="button" size="small" type="info" @click="sendCode" v-show="verifyShow" color="#f95959">发送验证码</van-button>
              <van-button slot="button" size="small" type="default" v-show="!verifyShow">{{count}}秒后重新获取</van-button>
            </van-field>
          </van-cell-group>
        </div>
        
        <!-- 提示信息 -->
        <div style="font-size: 14px;color:#a9a7a8;text-align: center;height: 30px;line-height: 30px ">
          信息提交后会有鲨鱼客服联系您, 请保持接听畅通!
        </div>
        <!-- 免费领取 -->
        <van-button type="primary" size="large" style="margin-top: 10px" round  @click="submitFun" color="#f95959">免费领取</van-button>
    </div>
    <!-- 中 -->
    <img v-for="img in imageList2" v-lazy="img" width="100%" style="display: block;"> 
    <!-- 表单2 -->
    <div class="form_box">
        <div style="border:1px solid #d4d4d4">
          <!-- 孩子姓名 -->
          <van-cell-group>
            <van-field
              v-model="form.name"
              label="孩子姓名"
              placeholder="请输入孩子姓名"
            />
          </van-cell-group>
          <!-- 孩子年龄 -->
          <van-field
            readonly
            clickable
            label="孩子年龄"
            :value="age"
            placeholder="请选择孩子年龄"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <!-- 家长手机号 -->
          <van-cell-group>
            <van-field
              v-model="form.phone"
              type="number"
              label="家长手机号"
              placeholder="请输入家长手机号"
            />
          </van-cell-group>
          <!-- 验证码 -->
          <van-cell-group>
            <van-field
              v-model="form.code"
              type="number"
              center
              clearable
              label="短信验证码"
              placeholder="请输入短信验证码"
            >
              <van-button slot="button" size="small" type="info" @click="sendCode" v-show="verifyShow" color="#f95959">发送验证码</van-button>
              <van-button slot="button" size="small" type="default" v-show="!verifyShow">{{count}}秒后重新获取</van-button>
            </van-field>
          </van-cell-group>
        </div>
        
        <!-- 提示信息 -->
        <div style="font-size: 14px;color:#a9a7a8;text-align: center;height: 30px;line-height: 30px ">
          信息提交后会有鲨鱼客服联系您, 请保持接听畅通!
        </div>
        <!-- 免费领取 -->
        <van-button type="primary" size="large" style="margin-top: 10px" round  @click="submitFun" color="#f95959">免费领取</van-button>
    </div>
    <!-- 下 -->
    <img v-for="img in imageList3" v-lazy="img" width="100%" style="display: block;">
  
  </div>
</template>

<script>
// @ is an alias to /src
import {sendVerificationCode , clueInputPromotionPage ,pageClick} from '@/api/squeeze'
import GraphValidateCode from '@/components/GraphValidateCode'

export default {
  name: 'page6',
  data(){
    return {
      form:{
        name:'',
        age:'',
        phone:'',
        consultationCourse:'4',
        sourceChannel:'',
        subSourceChannel:'',
        code:'',
      },
      showPicker: false,
      columns: ['不到4岁', '4岁', '5岁', '6岁', '7岁', '8岁', '9岁', '10岁', '11岁'],
       columnsArr: [3,4,5,6,7,8,9,10,11],
        ageIndex:0,
        age:'',
      verifyShow:true,//验证码显隐藏
      count:'',//验证码倒计时
      timer: null,//验证码函数
      imageList1: [
        'https://img.stem.cn/online/advertising/06/01.jpg',
        'https://img.stem.cn/online/advertising/06/02.jpg',
      ],
      imageList2: [
        'https://img.stem.cn/online/advertising/06/04.jpg',
        'https://img.stem.cn/online/advertising/06/05.jpg',
        'https://img.stem.cn/online/advertising/06/06.jpg',
        'https://img.stem.cn/online/advertising/06/07.jpg',
        'https://img.stem.cn/online/advertising/06/08.jpg',
        'https://img.stem.cn/online/advertising/06/09.jpg',
        'https://img.stem.cn/online/advertising/06/10.jpg',
        'https://img.stem.cn/online/advertising/06/11.jpg',
        'https://img.stem.cn/online/advertising/06/12.jpg',
        'https://img.stem.cn/online/advertising/06/02.jpg',
      ],
      imageList3: [
        'https://img.stem.cn/online/advertising/06/13.jpg',
      ],
      
    }
  },
  components:{
    GraphValidateCode
  },
  methods:{
    graphFun(){ //子组件通知父组件发短信验证码
      sendVerificationCode({phone:this.form.phone}).then( res =>{
        this.$toast.success('验证码发送成功');
        const TIME_COUNT = 60;
         if (!this.timer) {
           this.count = TIME_COUNT;
           this.verifyShow = false;
           this.timer = setInterval(() => {
           if (this.count > 0 && this.count <= TIME_COUNT) {
             this.count--;
            } else {
             this.verifyShow = true;
             // console.log("倒计时结束")
             clearInterval(this.timer);
             this.timer = null;
            }
           }, 1000)
          }
      })
    },
    onConfirm(value,index) {
      this.age = value;
      this.ageIndex = index;
      this.showPicker = false;
    },
    sendCode(){ //发送验证码
      let data = this.form;
        if(!/(^1[0-9]{10}$)/.test(data.phone)){
          this.$toast('请输入正确的手机号码');
          return;
        }
        this.$refs.graphOneself.init(data.phone);
    },
    submitFun(){ //表单提交
        let data = this.form;
        if(!data.name){
          this.$toast('请输入孩子姓名');
          return;
        }
        if(!this.age){
          this.$toast('请输入孩子年龄');
          return;
        }
        if(!/(^1[0-9]{10}$)/.test(data.phone)){
          this.$toast('请输入正确的手机号码');
          return;
        }
        if(!data.code || data.code.length !== 4){
          this.$toast('请输入正确的验证码');
          return;
        }
        data.sourceChannel = this.$route.query.c || "";
        data.subSourceChannel = this.$route.query.sc || "";
        this.form.age = this.columnsArr[this.ageIndex];
        clueInputPromotionPage(data).then( res =>{
        this.$toast.success('提交成功');
        this.form = {
          name:'',
          age:'',
          phone:'',
          consultationCourse:'4',
          sourceChannel:'',
          subSourceChannel:'',
          code:'',
        };
        this.age = ''
        this.verifyShow = true;
      })
    }
  },
  created(){
    pageClick({
      sourceChannel:this.$route.query.c || "",
      sourceChannelSub:this.$route.query.sc || "",
      pageLink:this.$route.fullPath
    })
  }
}
</script>
<style lang="scss" scoped>
  @function vw($px) {
    @return ($px / 750) * 100vw
  };
  .page6 {
    position: relative;
    .form_box {
      width: 100%;
      padding:20px;
      box-sizing:border-box;
    }
    
  }
</style>
